import { IndexPageVariant, OS } from '../models/indexPageVariant';

export const iosVariant: IndexPageVariant = {
  id: OS.IOS,
  name: 'iOS',
  installationSteps: [],
  downloadLink: 'ios-appstore.lnk'
};
